import { useSelector } from 'react-redux'
import { Navigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { routerFactory } from '@/factories'
import { useDesignVersionToggle } from '@/hooks'
import { BASE_CLIENT_DASHBOARD_QUERY_KEY } from '@/api/clients/get-clients-dashboard'
import ClientProfileView from '@/components/Clients/ClientProfileView/ClientProfileView'
import { Page } from '@/components/layout/page'
import { useSnackbar } from '@/helpers/hooks/useSnackbar'
import {
  formatBuildingsForFilter,
  selectActiveBuilding,
  selectBuildingsForFilter,
} from '@/reducers/buildingSelectorReducer'
import { selectUserBuilding, selectUserRole } from '@/reducers/userDataReducer'
import { resetQueries } from '@/utils'
import { useGetClientById } from '@/api/clients/get-client-by-id'

export const ClientDetailsPage = () => {
  const { t } = useTranslation(['clients-legacy'])
  const userRole = useSelector(selectUserRole)

  const selectedAppBuilding = useSelector(selectActiveBuilding)
  const selectedBuilingId = selectedAppBuilding?.id

  const buildingsForFilter = useSelector(selectBuildingsForFilter)
  const userBuildings = useSelector(selectUserBuilding)
  const buildings =
    userRole === 'ShiftManager'
      ? formatBuildingsForFilter(userBuildings ? [userBuildings] : [])
      : buildingsForFilter

  const { clientId } = useParams()
  const { navigateBack } = routerFactory.useRouter()
  const { displaySnackbar } = useSnackbar()

  const { redirect, toggle: handleUIToggle } = useDesignVersionToggle({
    group: 'clients',
    screen: 'Client profile',
    to: { params: { clientId }, path: '/dashboard/clients/:clientId' },
    version: 'legacy',
  })

  const { data, isFetching } = useGetClientById(clientId)

  if (redirect) return redirect

  if (!data && !isFetching) {
    return <Navigate replace to="/dashboard/clients" />
  }

  // Note: Temporary solution. Most likely will be changed once client details page is refactored to use new components
  if (!data || !selectedAppBuilding) {
    return null
  }

  return (
    <Page>
      <ClientProfileView
        clientData={data}
        userRole={userRole}
        buildings={buildings}
        closeProfileView={() => navigateBack({ path: '/dashboard/clients' })}
        showUserStatusPopup={({ status }) =>
          displaySnackbar(t('clients-legacy:snackbar.clientStatus', { status }))
        }
        reduceAllClientsCountByOne={() => resetQueries([BASE_CLIENT_DASHBOARD_QUERY_KEY])}
        buildingId={selectedBuilingId}
        onUIToggle={handleUIToggle}
      />
    </Page>
  )
}
